module.exports = __webpack_public_path__ + "static/media/logo_tavi_colored.453f1428.png";